export const clearLocalStorageAfterLogout = () => {
  let shopCode = localStorage.getItem('win-board-localstorage-shop-info');
  localStorage.clear();
  localStorage.setItem('win-board-localstorage-shop-info', shopCode || "");
};

export default clearLocalStorageAfterLogout;
